export default __webpack_public_path__ + "static/nucleus-2e8784d3383aaed222de08f8d9270705e06f76cb13a158eb05921db99790ed29.png";